import React from "react";
import { MdCircle } from "react-icons/md";
import { RxExternalLink } from "react-icons/rx";
import { Link } from "react-router-dom";
import {
  sortAmount,
  sortDateTime,
  sortPaymentCategory,
  upiIntentLogoDictionary,
} from "../utils/utils";
import HoverToDisplayFullTitle from "../../reusableComponents/HoverToDisplayFullTitle";
import { colorBrandObject } from "../../../constants/brandings";
import { useAuth } from "../../context/API_Client";
import TransactionStatusSchema from "../../reusableComponents/TransactionStatusSchema";

const TransactionRenderer = ({ data }) => {
  const transacId = data.transactionId;
  const { isAuthorizedPermission } = useAuth();
  const canViewTransaction = isAuthorizedPermission("VIEW_ORDER_DETAILS") || isAuthorizedPermission("VIEW_OWN_ORDER_DETAILS");

  return (
    <div
      style={{
        display: "flex",
        marginLeft: "-12px",
        alignItems: "center",
        minWidth: "100px",
        paddingRight: "30px",
      }}
    >
      <div
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          flex: 1,
        }}
      >
        {transacId && <HoverToDisplayFullTitle title={transacId} len={12} />}
        {canViewTransaction && (
          <Link
            id="transaction-all-link"
            to={
              "/transacs/payment_details/transaction_Details?transactionId=" + transacId
            }
            target="_blank"
          >
            <RxExternalLink
              style={{
                width: "24px",
                height: "16px",
                cursor: "pointer",
                position: "absolute",
                right: "0",
                marginRight: "16px",
                color: `${colorBrandObject?.actionIconColor}`
              }}
            />
          </Link>
        )}
      </div>

    </div>

  );
};

export const allTransactionschema = (operationPermissions) => {
  const { isAuthorizedPermission } = useAuth;
  return {
    metadata: {
      title: "All Transaction",
      minHeight: 600,
      position: "relative",
      rowHeight: 60,
      showTitle: false,
      defaultSortInfo: { name: "timestamp", dir: -1 },
      defaultVisible: [
        "transactionId",
        "operationName",
        "categoryDataForSorting",
        "amount",
        "timestamp",
        "pspCode",
        "operationStatus",
      ],
    },
    fields: [
      {
        name: "transactionId",
        header: "Transaction ID",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 180,
        defaultFlex: 1,
        textAlign: "center",
        sortable: false,
        render: TransactionRenderer,
      },
      {
        name: "timestamp",
        header: "Created At",
        visible: true,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        sort: sortDateTime,
        minWidth: 220,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.timestamp}</span>
        ),
      },
      {
        name: "operationName",
        header: "Operations",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 190,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ value }) => (
          <span
            style={{ display: "flex", marginLeft: "-12px", alignItems: "center" }}
          >
            <MdCircle
              style={{
                width: "8px",
                height: "8px",
                color:
                  value === ("Authorisation" || "Capture")
                    ? "#188D63"
                    : "rgba(158, 87, 7, 1)",
              }}
            />
            &nbsp; &nbsp;
            {value}
          </span>
        ),
      },
      {
        name: "categoryDataForSorting",
        header: "Category",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 120,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span
            style={{ display: "flex", marginLeft: "-15px", alignItems: "center" }}
          >
            {data?.paymentMethodTypeLocale && (
              <img
                src={upiIntentLogoDictionary(data?.paymentMethodSubBrand) || data?.paymentMethodLogoUrl}
                style={{
                  height: "28px",
                  width: "28px",
                  objectFit: "contain",
                  marginRight: "8px",
                  mixBlendMode: "multiply",
                }}
              />
            )}
            {data?.paymentMethodTypeLocale === "Buy Now Pay Later"
              ? "BNPL"
              : data?.paymentMethodTypeLocale}
          </span>
        ),
        sort: sortPaymentCategory,
      },
      {
        name: "amount",
        header: "Amount",
        visible: true,
        type: "number",
        filtering: false,
        minWidth: 150,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span style={{ display: "flex", marginLeft: "-12px" }}>
            {`${data?.currencyCode} ${data?.amountLocaleFull}`}
          </span>
        ),
      },
      {
        name: "pspCode",
        header: "Processor",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 140,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ data }) => (
          <span
            style={{ display: "flex", marginLeft: "-20px", alignItems: "center" }}
          >
            {data?.pspCodeLogoURL && (
              <img
                src={data?.pspCodeLogoURL}
                style={{
                  height: "28px",
                  width: "28px",
                  objectFit: "contain",
                  marginRight: "8px",

                  mixBlendMode: "multiply",
                }}
              />
            )}
            {data?.pspCodeLocale ? data?.pspCodeLocale?.toLowerCase() == "none" ? "" : data?.pspCodeLocale : ""}
          </span>
        ),
      },
      // {
      //   name: "finalStatus",
      //   header: "Status",
      //   visible: true,
      //   type: "string",
      //   filtering: false,
      //   minWidth: 150,
      //   defaultFlex: 1,
      //   textAlign: "start",
      //   sortable: false,
      //   render: ({ value }) => {
      //     let backgroundColor;
      //     let color;
      //     let uValue = value;
      //     if (uValue === "Approving"
      //       || uValue === "Authorizing"
      //       || uValue === "Notifying Shopper"
      //       || uValue === "Refund Initiated"
      //       || uValue === "Refund Review Initiated"
      //       || uValue === "Capturing") {
      //       backgroundColor = "#E6F7FF";
      //       color = "#1890FF";
      //     } else if (
      //       uValue === "Pending Authorization" ||
      //       uValue === "Input Pending" ||
      // uValue === "Refund Pending Review" ||
      // uValue === "Awaiting Split Instructions" ||
      //       uValue === "Cancel Initiated" ||
      //       uValue === "Cancelled" ||
      //       uValue === "Settled With Conflicts"
      //     ) {
      //       backgroundColor = "#FBEFCB";
      //       color = "#9E5707";
      //     } else if (
      //       uValue === "Approved" ||
      //       uValue === "Sale Approved" ||
      //       uValue === "Authorized" ||
      //       uValue === "Captured" ||
      //       uValue === "Partially Captured" ||
      //       uValue === "Refunded" ||
      //       uValue === "Settled" ||
      //       uValue === "Shopper Notified" ||
      //       uValue === "Partially Refunded"
      //     ) {
      //       backgroundColor = "#D5FBD2";
      //       color = "#0B6A48";
      //     } else if (
      //       uValue === "Approve Failed" ||
      //       uValue === "Capture Timed Out" ||
      //       uValue === "Authorization Failed" ||
      //       uValue === "Approve Timed Out" ||
      //       uValue === "Capture Failed" ||
      //       uValue === "Authorization Timed Out" ||
      //       uValue === "Refund Failed" ||
      //       uValue === "Cancellation Failed" ||
      //       uValue === "Cancellation Timed Out" ||
      //       uValue === "Shopper Notification Failed" ||
      //       uValue === "Shopper Notification Timed Out" ||
      //       uValue === "Refund Timed Out" ||
      //       uValue === "Sale Timed Out" ||
      //       uValue === "Sale Failed"
      //     ) {
      //       backgroundColor = "#FDE3D6";
      //       color = "#B9232F";
      //     } else if (uValue === 'EXPIRED') {
      //       backgroundColor = "#D9D9D9";
      //       color = "#595959";
      //     }
      //     return (
      //       <span
      //         style={{
      //           marginLeft: "-20px",
      //           paddingBottom: "6px",
      //           paddingRight: "8px",
      //           paddingLeft: "8px",
      //           paddingTop: "5px",
      //           borderRadius: "8px",
      //           backgroundColor,
      //           color,
      //           // textTransform: "uppercase",
      //         }}
      //       >
      //         {value}
      //       </span>
      //     );
      //   },
      // },

      {
        name: "clientPosId",
        header: "Store ID",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.clientPosId}</span>
        ),
      },
      {
        name: "countryCode",
        header: "Country",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.countryCode}</span>
        ),
      },
      {
        name: "currencyCode",
        header: "Currency",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.currencyCode}</span>
        ),
      },
      {
        name: "legalEntity",
        header: "Business Unit",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.legalEntity}</span>
        ),
      },
      {
        name: "merchantId",
        header: "Merchant ID",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.merchantId}</span>
        ),
      },
      {
        name: "noOfPspRetries",
        header: "No. of PSP Retries",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.noOfPspRetries}</span>
        ),
      },
      {
        name: "operationId",
        header: "Operation ID",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.operationId}</span>
        ),
      },

      {
        name: "orderId",
        header: "Order ID",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 200,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.orderId}</span>
        ),
      },
      {
        name: "reasonCode",
        header: "Reason Code",
        visible: false,
        type: "string",
        filtering: false,
        textAlign: "start",
        sortable: false,
        minWidth: 220,
        defaultFlex: 1,
        render: ({ data }) => (
          <span style={{ marginLeft: "-12px" }}>{data.reasonCode}</span>
        ),
      },
      {
        name: "operationStatus",
        header: "Status",
        visible: true,
        type: "string",
        filtering: false,
        minWidth: 270,
        defaultFlex: 1,
        textAlign: "start",
        sortable: false,
        render: ({ value }) => (<TransactionStatusSchema status={value} />)
      },
    ],
  }
}
